import { CustomReportsTab } from './reports-custom-tab'
import { TrivieReportsTab } from './reports-trivie-tab'

export const reportsTabs = [CustomReportsTab, TrivieReportsTab]
